import { render, staticRenderFns } from "./SelectionKol.vue?vue&type=template&id=3144c53c&scoped=true"
import script from "./SelectionKol.vue?vue&type=script&lang=js"
export * from "./SelectionKol.vue?vue&type=script&lang=js"
import style0 from "./SelectionKol.vue?vue&type=style&index=0&id=3144c53c&prod&lang=scss&scoped=true"
import style1 from "./SelectionKol.vue?vue&type=style&index=1&id=3144c53c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144c53c",
  null
  
)

export default component.exports